module.exports = __webpack_public_path__ + "static/media/Cat.bdd3fb9b.png";